import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import GlobalStyle from './styles/global';
import Routes from './routes';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <GlobalStyle />
      <Toaster />
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </>
  );
}

export default App;
